module.exports = __webpack_public_path__ + "static/img/thumb_9.c67c827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_9.png
// module id = 8d2V
// module chunks = 0